module.exports = __webpack_public_path__ + "img/mooby.6bc67e6d.png";